import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'Positions',
    breadcrumbName: 'Positions',
  },
];

const Positions = () => {
  return (
    <>

      <PageHeader title="Positions" breadcrumb={{ routes }} subTitle="Positions-Values" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul>
          <li>pos_{`{value}`}</li>
        </ul>
        <ul>
          <li>static</li>
          <li>relative</li>
          <li>absolute</li>
          <li>fixed</li>
        </ul>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="pos_static"></div>
<div class="pos_relative"></div>
<div class="pos_absolute"></div>
<div class="pos_fixed"></div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default Positions;
